
<div class="bg-white p-6 rounded-lg shadow-md">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-bold text-gray-800">Aceites de Termo</h2>
  </div>

  <form (submit)="filter()" class="flex gap-4 mb-6">
    <div class="flex-1">
      <input 
        type="text" 
        [(ngModel)]="fornecedorId" 
        name="fornecedorId" 
        placeholder="Filtrar por Fornecedor ID" 
        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
    <button type="submit" class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
      Filtrar
    </button>
    <button type="button" (click)="resetFilter()" class="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors">
      Limpar
    </button>
  </form>

  <div *ngIf="loading" class="text-center py-8 text-gray-500">
    Carregando...
  </div>

  <div *ngIf="!loading && items.length === 0" class="text-center py-8 text-gray-500 bg-gray-50 rounded-md">
    Nenhum aceite encontrado.
  </div>

  <div *ngIf="items.length > 0" class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Protocolo</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Versão</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">IP Origem</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data Aceite</th>
          <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let item of items" class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ item.protocoloAceite }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            <div>{{ item.fornecedorNome }}</div>
            <div class="text-xs text-gray-400">{{ item.fornecedorId }}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.usuarioEmail }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.versaoContrato }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">{{ item.ipOrigem }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.dataAceite | date:'short' }}</td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <a [routerLink]="['/admin/term-acceptances', item.id]" class="text-indigo-600 hover:text-indigo-900 font-medium">
              Detalhes
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex items-center justify-between mt-6" *ngIf="totalPages > 1">
    <div class="text-sm text-gray-500">
      Página {{ page }} de {{ totalPages }} (Total: {{ totalItems }})
    </div>
    <div class="flex gap-2">
      <button 
        (click)="prev()" 
        [disabled]="page === 1" 
        class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Anterior
      </button>
      <button 
        (click)="next()" 
        [disabled]="page >= totalPages" 
        class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Próxima
      </button>
    </div>
  </div>
</div>
